/**
 * PA analytics summary — encounter scope (X of Y).
 * @see docs/PA_ANALYTICS_UI_ENCOUNTER_SCOPE.md
 */
export function getPaEncounterScopeDisplay(summary) {
  const withPA = Number(summary?.total_encounters_with_pa ?? summary?.total_requests ?? 0);
  const rawInScope = summary?.total_encounters_in_scope;

  if (rawInScope == null || rawInScope === '') {
    return {
      withPA,
      title: 'Encounters with PA',
      subtitle: 'With PA items',
      hint: null,
    };
  }

  const inScope = Number(rawInScope) || 0;

  if (inScope === 0) {
    return {
      withPA,
      title: 'Encounters with PA',
      subtitle: withPA > 0 ? `${withPA.toLocaleString()} with PA` : 'No encounters in scope',
      hint: null,
    };
  }

  return {
    withPA,
    inScope,
    title: 'Encounters with PA',
    subtitle: `${withPA.toLocaleString()} of ${inScope.toLocaleString()} in scope`,
    hint:
      withPA < inScope
        ? 'Encounters without PA items are excluded from PA cost totals'
        : null,
  };
}

/**
 * Prefer endpoint-local field_guide, else fall back to summary guide.
 */
export function mergePaFieldGuides(...guides) {
  const byField = new Map();
  guides.forEach((guide) => {
    if (!Array.isArray(guide)) return;
    guide.forEach((entry) => {
      const key = entry?.field || entry?.key;
      if (!key || byField.has(key)) return;
      byField.set(key, entry);
    });
  });
  return Array.from(byField.values());
}
